import { Component, Input } from '@angular/core';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-spinner',
  template: `
    @if (loading$ | async) {
      <div class="spinner">
        <div class="center">
          <mat-spinner [diameter]="diameter" />
        </div>
      </div>
    }
    `,

  styles: `

    .spinner {
    height: 100vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.286);
    z-index: 1000;
    top: 0;
    left: 0;
    position: fixed;
  }

  .center {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    color: #0093a1;
  }
    `,
  standalone: false,
})
export class SpinnerComponent {
  @Input() diameter: number = 100;
  loading$ = this.loadingService.loading$;

  constructor(private readonly loadingService: LoadingService) {}
}
